var chunkToChildrenMap = {
	"src_views_AI_agent_home_vue": [
		"vendors",
		"src_utils_echarts_js"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };